<script>
import { apiSecond } from '@/boot/axios'
import {
	hasNotificationHref,
	notificationHref,
	notificationLink,
	notificationText,
} from '@/helpers'
import {
	unseenState,
	loadUnseen,
	markSeen,
	markAllSeen,
} from '@/components/system-updates/unseenStore'
import { categoryColor, formatUpdateDate } from '@/components/system-updates/utils'

export default {
	data() {
		return {
			notificationsHeader: [],
			notifyClick: false,
			updates: unseenState,
		}
	},
	computed: {
		notificationsCount() {
			return Array.isArray(this.notificationsHeader) ? this.notificationsHeader.length : 0
		},
		totalCount() {
			return this.notificationsCount + this.updates.count
		},
		totalLabel() {
			return this.totalCount > 99 ? '99+' : this.totalCount
		},
		hasUpdates() {
			return this.updates.count > 0
		},
	},
	methods: {
		notificationText,
		notificationLink,
		notificationHref,
		hasNotificationHref,
		categoryColor,
		formatUpdateDate,
		getData() {
			this.notificationsHeader = []
			apiSecond
				.get('v1/notifications', {})
				.then((response) => {
					this.notificationsHeader = response.data
				})
				.catch(() => {})
		},
		readSet(index, link) {
			apiSecond
				.post('v1/notifications/read', {
					index: index,
				})
				.then(() => {
					this.notifyClick = false
					this.getData()
					// this.$router.push({ path: link });
					// window.location.href = link;
					window.open(link, '_blank')
				})
				.catch(() => {})
		},
		headerNotify() {
			this.notifyClick = !this.notifyClick
		},
		updatesPath() {
			return '/' + this.$i18n.locale + '/updates'
		},
		openUpdate(item) {
			this.notifyClick = false
			markSeen(item.id)
			this.$router.push(this.updatesPath() + '/' + item.id)
		},
		openAllUpdates() {
			this.notifyClick = false
			markAllSeen()
			this.$router.push({ path: this.updatesPath() })
		},
		onDocumentClick(event) {
			if (this.notifyClick && this.$el && !this.$el.contains(event.target)) {
				this.notifyClick = false
			}
		},
	},
	mounted() {
		this.getData()
		loadUnseen()
		document.addEventListener('click', this.onDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.onDocumentClick)
	},
}
</script>

<template>
	<div class="header__notify--wrapper" v-bind:class="{ 'header__notify--active': notifyClick }">
		<div class="header__notify">
			<div class="header__notify--btn" @click="headerNotify">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9zM13.73 21a1.999 1.999 0 01-3.46 0M2 8c0-2.2.7-4.3 2-6M22 8a10 10 0 00-2-6" stroke="#5ABB5E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
				<div class="header__notify--number" v-if="totalCount">
					{{ totalLabel }}
				</div>
			</div>
		</div>
		<div class="header__notify--absol" v-if="hasUpdates || notificationsCount">
			<div v-if="hasUpdates" class="su-bell">
				<div class="su-bell__head">
					<span class="su-bell__title">{{ $t('system_updates.bell_title') }}</span>
					<span class="su-bell__count">{{ updates.count }}</span>
				</div>
				<ul class="su-bell__list">
					<li v-for="item in updates.items" :key="item.id">
						<button type="button" class="su-bell__item" @click="openUpdate(item)">
							<span
								class="su-bell__dot"
								:style="{ backgroundColor: categoryColor(item.category) }"
							></span>
							<span class="su-bell__text">
								<span class="su-bell__item-title">{{ item.title }}</span>
								<span class="su-bell__meta">
									<template v-if="item.category && item.category.name"
										>{{ item.category.name }} · </template
									>{{ formatUpdateDate(item.published_at) }}
								</span>
							</span>
						</button>
					</li>
				</ul>
				<button type="button" class="su-bell__all" @click="openAllUpdates">
					{{ $t('system_updates.bell_all') }}
					<svg
						width="14"
						height="14"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M5 12h14M13 6l6 6-6 6" />
					</svg>
				</button>
			</div>

			<div class="header__notify--list" v-if="notificationsCount">
				<div v-if="hasUpdates" class="su-bell__title su-bell__title--section">
					{{ $t('system_updates.bell_notifications') }}
				</div>
				<ul>
					<li v-for="(item, index) in notificationsHeader" :key="index">
						<a
							v-if="notificationLink(item)"
							@click="readSet(index, notificationLink(item))"
							target="_blank"
							class="pointer"
						>
							<span>{{ notificationText(item) }}</span>
						</a>
						<a
							v-else-if="hasNotificationHref(item)"
							class="pointer"
							@click="readSet(index, notificationHref(item))"
						>
							{{ notificationText(item) }}
						</a>
						<span v-else>{{ notificationText(item) }}</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="header__notify--absol" v-else>
			<div class="header__notify--list">
				{{ $t('notification.not_new') }}
			</div>
		</div>
	</div>
</template>

<style>
.header__notify--absol {
	max-height: min(70vh, 520px);
	overflow-y: auto;
	overscroll-behavior: contain;
}

.su-bell {
	margin: -4px -8px 0;
}

.su-bell + .header__notify--list {
	margin-top: 14px;
	padding-top: 14px;
	border-top: 1px solid #eef3fa;
}

.su-bell__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 0 8px 8px;
}

.su-bell__title {
	font-size: 13px;
	font-weight: 600;
	color: #151d48;
}

.su-bell__title--section {
	margin-bottom: 10px;
}

.su-bell__count {
	min-width: 22px;
	padding: 2px 7px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 600;
	text-align: center;
	color: #ffffff;
	background: #157fee;
}

.su-bell__list {
	list-style: none;
	margin: 0;
	padding: 0;
}

.su-bell__item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	width: 100%;
	padding: 8px;
	border: none;
	border-radius: 8px;
	background: transparent;
	text-align: left;
	cursor: pointer;
	transition: background 0.2s ease;
}

.su-bell__item:hover,
.su-bell__item:focus-visible {
	background: #f2f8ff;
	outline: none;
}

.su-bell__dot {
	flex: 0 0 8px;
	width: 8px;
	height: 8px;
	margin-top: 5px;
	border-radius: 50%;
}

.su-bell__text {
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.su-bell__item-title {
	font-size: 12px;
	font-weight: 500;
	line-height: 1.3;
	color: #151d48;
	overflow-wrap: anywhere;
}

.su-bell__meta {
	font-size: 11px;
	line-height: 1.3;
	color: #8a97b1;
}

.su-bell__all {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	margin: 6px 8px 0;
	padding: 0;
	border: none;
	background: transparent;
	font-size: 12px;
	font-weight: 600;
	color: #157fee;
	cursor: pointer;
}

.su-bell__all:hover {
	text-decoration: underline;
}

@media (max-width: 575px) {
	.header__notify--absol {
		width: min(300px, calc(100vw - 24px));
		right: -40px;
	}
}

.su-bell__item-title {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
